// import * as React from "react";
// import * as ReactDOM from "react-dom";
// import {
//   goBack,
//   goTo,
//   popToTop,
//   Link,
//   Router,
//   getCurrent,
//   getComponentStack,
// } from "react-chrome-extension-router";
// import React, { Component } from "react";
// class Three extends Component {
//   constructor() {
//     super();
//   }
//   render() {
//     return (
//       <div onClick={() => popToTop()}>
//         <h1>{this.props.message}</h1>
//         <p>Click me to pop to the top</p>
//       </div>
//     );
//   }
// }

// class Two extends Component {
//   constructor() {
//     super();
//   }
//   render() {
//     return (
//       <div>
//         This is component Two. I was passed a message:
//         <p>{this.props.message}</p>
//         <button onClick={() => goBack()}>
//           Click me to go back to component One
//         </button>
//         <button onClick={() => goTo(Three, { message: this.props.message })}>
//           Click me to go to component Three!
//         </button>
//       </div>
//     );
//   }
// }

// class One extends Component {
//   constructor() {
//     super();
//   }

//   render() {
//     return (
//       <Link component={Two} props={{ message: "I came from component one!" }}>
//         This is component One. Click me to route to component Two
//       </Link>
//     );
//   }
// }

// class App extends Component {
//   constructor() {
//     super();
//   }

//   // useEffect() {
//   //   const { component, props } = getCurrent();
//   //   console.log(
//   //     component
//   //       ? `There is a component on the stack! ${component} with ${props}`
//   //       : `The current stack is empty so Router's direct children will be rendered`
//   //   );
//   //   const components = getComponentStack();
//   //   console.log(`The stack has ${components.length} components on the stack`);
//   // }

//   render() {
//     return (
//       <Router>
//         <One />
//       </Router>
//     );
//   }
// }

// export default App;

// const App = () => {
//   useEffect(() => {
//     const { component, props } = getCurrent();
//     console.log(
//       component
//         ? `There is a component on the stack! ${component} with ${props}`
//         : `The current stack is empty so Router's direct children will be rendered`
//     );
//     const components = getComponentStack();
//     console.log(`The stack has ${components.length} components on the stack`);
//   });
//   return (
//     <Router>
//       <One />
//     </Router>
//   );
// };

// ReactDOM.render(<App />, document.getElementById("root"));

import "./App.css";
import React, { Component } from "react";
import MyNav from "./components/nav";
// import Home from "./home";
// import InfoBox from "./components/infobox";
import "bootstrap/dist/css/bootstrap.min.css";
// import CompanyTable from "./components/companyTable";
// import firebase from "firebase";
// import "firebase/database";
// import "firebase/auth";
// import Company from "./components/company";
// import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
// import { Form, Dropdown } from "react-bootstrap";
// import { Typeahead } from "react-bootstrap-typeahead"; // ES2015
import "react-bootstrap-typeahead/css/Typeahead.css";
// import { getAuth, linkWithCredential, onAuthStateChanged } from "firebase/auth";
// import Contribute from "./components/contribute";
// import { Button } from "@material-ui/core";
// import Trends from "./components/trends";
import { getLogoURL } from "./util.js";
import Routers from "./components/routers";
class App extends Component {
  render() {
    return (
      <React.Fragment>
        <header>
          <MyNav />
        </header>

        <Routers />

        <footer className="footer lfont mt-auto">
          <hr className="mt-5 mb-2 text-muted" />
          <div className="container pt-4 pb-5">
            <div className="row">
              <div className="col-12 col-md-6">
                <h3>Status-fyi</h3>
                {/* <br /> */}
                <span className="txt-90 text-muted">
                  Know your internship application status
                  <br />
                  {/* <small class="text-muted">© 2017-2021</small> */}
                </span>
              </div>
            </div>
          </div>
        </footer>
      </React.Fragment>
    );
  }
}

export default App;
export { getLogoURL };
